import { Component, OnInit, ViewChild } from '@angular/core';

import { DepartamentModel } from '../shared/model/departament.model';
import { ReturnMessageModel } from '../shared/model/return-message.model';
import { DepartamentService } from '../shared/service/departament.service';
import { MessageComponent } from '../shared/component/message/message.component';

@Component({
  selector: 'app-departament',
  templateUrl: './departament.component.html',
  styleUrls: ['./departament.component.css']
})
export class DepartamentComponent implements OnInit {

  @ViewChild(MessageComponent) message: MessageComponent;

  lastEvent: any;
  totalRecords: number;

  departaments: DepartamentModel[] = [];
  departament: DepartamentModel = new DepartamentModel();

  constructor(private departamentService: DepartamentService) { }

  ngOnInit() {}

  lazy(e){
    this.lastEvent = e;
    this.departamentService.getPaginated(e.first, e.rows).subscribe(departaments => {
      this.departaments = departaments['rows'] as DepartamentModel[];
      this.totalRecords = departaments['count'];
    });
  }

  onSelect(e) {
    this.departament = e.data as DepartamentModel;
  }
  
  onNew(){
    this.departament = new DepartamentModel();
  }

  onSave(){
    this.departamentService.save(this.departament).subscribe((r: ReturnMessageModel) => {
      this.message.success(r.message);
      this.lazy(this.lastEvent);
      this.onNew();
    }, (error: ReturnMessageModel) => {
      this.message.error();
    });
  }

  onDelete(){
    this.departamentService.delete(this.departament.id).subscribe((r: ReturnMessageModel) => {
      if (r.error) this.message.error(r.message); else this.message.success(r.message);
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  validate(): boolean {
      return DepartamentModel.validate(this.departament);
  }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/departament/departament.component.ts